import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem('access_token') || null

    if (token != null) {
      config.headers.Authorization = `${token}`
    }

    return config
  },
  function(err) {
    return Promise.reject(err)
  }
)
